import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { http_get } from '../utils/api_client';
import { API_ENDPOINTS } from '../utils/endpoints';
import Loader from '../../organisms/loader/Loader';
import ChecklistBuilder from './ChecklistBuilder';
import './ChecklistBuilder.scss';

// BL-084 — Checklist builder entry. Mounted by the App router at
// /:companySlug/checklists/:lmSlug/edit. Loads the checklist (with items) and
// hands it to the builder. Store Provider is supplied by the router; we add the
// DnD provider here for item reordering.
const EditPage = () => {
  const { companySlug, lmSlug } = useParams();
  const [checklist, setChecklist] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    http_get(API_ENDPOINTS.GET_CHECKLIST(lmSlug))
      .then(({ data }) => { if (!cancelled) setChecklist(data); })
      .catch(() => { if (!cancelled) setChecklist(null); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [lmSlug]);

  return (
    <DndProvider backend={HTML5Backend}>
      {loading ? (
        <Loader />
      ) : checklist ? (
        <ChecklistBuilder slug={lmSlug} companySlug={companySlug} initial={checklist} />
      ) : (
        <div className="cl-builder__missing">Checklist not found.</div>
      )}
    </DndProvider>
  );
};

export default EditPage;
